/* HURRIQ V2 product: option to variant mapping, quantity stepper, sticky add to cart. */
(function () {
  document.querySelectorAll('[data-hq-product]').forEach(function (root) {
    var section = root.closest('.hq');
    var dataEl = section.querySelector('[data-hq-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = section.querySelector('[data-hq-variant-input]');
    var priceBox = section.querySelector('[data-hq-price]');
    var stickyPrice = section.querySelector('[data-hq-sticky-price]');
    var atcs = section.querySelectorAll('[data-hq-atc]');

    function selected() {
      var out = [];
      section.querySelectorAll('[data-hq-option]').forEach(function (el) {
        var i = parseInt(el.getAttribute('data-hq-option'), 10) - 1;
        if (el.type === 'radio') { if (el.checked) out[i] = el.value; }
        else out[i] = el.value;
      });
      return out;
    }
    function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
    function update() {
      var sel = selected();
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return sel[i] === undefined || o === sel[i]; }); });
      if (!v) { atcs.forEach(function (b) { b.disabled = true; b.textContent = 'Unavailable'; }); return; }
      idInput.value = v.id;
      var html = '<span class="hq-price__now">' + esc(v.price) + '</span>';
      if (v.compare) html += '<span class="hq-price__was">' + esc(v.compare) + '</span><span class="hq-price__save">Save ' + v.save + '%</span>';
      priceBox.innerHTML = html;
      if (stickyPrice) stickyPrice.textContent = v.price;
      atcs.forEach(function (b) { b.disabled = !v.available; b.textContent = v.available ? 'Add to cart' : 'Sold out'; });
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    section.querySelectorAll('[data-hq-option]').forEach(function (el) { el.addEventListener('change', update); });

    var qty = section.querySelector('input[name="quantity"]');
    section.querySelectorAll('[data-hq-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-hq-qty'), 10);
        qty.value = Math.min(20, Math.max(1, n));
      });
    });

    var sticky = section.querySelector('[data-hq-sticky]');
    var mainAtc = section.querySelector('.hq-atc');
    if (sticky && mainAtc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var off = entries[0].boundingClientRect.top < 0 && !entries[0].isIntersecting;
        sticky.classList.toggle('is-on', off);
        sticky.setAttribute('aria-hidden', off ? 'false' : 'true');
        sticky.querySelector('button').tabIndex = off ? 0 : -1;
      }).observe(mainAtc);
    }
  });
})();
